import { render, staticRenderFns } from "./EditModeBanner.vue?vue&type=template&id=6131ccda"
import script from "./EditModeBanner.vue?vue&type=script&lang=ts"
export * from "./EditModeBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports